import { render, staticRenderFns } from "./recovery_case.vue?vue&type=template&id=4db9dd74&scoped=true&"
import script from "./recovery_case.vue?vue&type=script&lang=js&"
export * from "./recovery_case.vue?vue&type=script&lang=js&"
import style0 from "./recovery_case.vue?vue&type=style&index=0&id=4db9dd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9dd74",
  null
  
)

export default component.exports